<template>
  <section
    v-show="show"
    class="contact-card-singleton-container"
    :class="{
      'high-contrast' : isHighContrastThemeActive,
      'mobile-container' : $vuetify.breakpoint.mobile
    }"
    :style="POSITIONING"
    @mouseenter="keepOpen"
    @mouseleave="close"
  >
    <SmsContactCard ref="contactCard" quick-message :contact="contact" @message-sent="syncClose" />
  </section>
</template>

<script>
import SmsContactCard from '@/components/SmsContactCard/SmsContactCard';
import ThemeMixin from '@/mixins/ThemeMixin';

export default {
  name: 'SmsContactCardSingleton',

  mixins: [ ThemeMixin ],

  components: { SmsContactCard },

  data() {
    return {
      contact: {
        type: Object,
        default: () => {
          return {};
        }
      },
      position: {
        x: 0,
        y: 0
      },
      show: false,
      alwaysOpen: false,
      closeTimeoutRef: null
    }
  },

  computed: {
    POSITIONING() {
      return {
        top: `${ this.position.y }px`,
        left: `${ this.position.x }px`
      };
    }
  },

  created() {
    this.$root.$on('open-contact-card', this.open);
    this.$root.$on('close-contact-card', this.close);
  },

  beforeDestroy() {
    this.$root.$off('open-contact-card');
    this.$root.$off('close-contact-card');
  },

  methods: {
    keepOpen() {
      clearTimeout(this.closeTimeoutRef);
    },

    open({ contact, x, y }) {
      this.contact = contact;
      this.position.x = x;
      this.position.y = y;
      this.show = true;
      clearTimeout(this.closeTimeoutRef);
      this.$refs.contactCard.clearMessageInput();
    },

    syncClose() {
      clearTimeout(this.closeTimeoutRef);
      this.show = false;
    },

    close() {
      this.closeTimeoutRef = setTimeout(() => {
        this.show = false;
      }, 300);
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-card-singleton-container {
  position: absolute;
  z-index: 100;
  min-width: 360px;
  min-height: 120px;
}

.contact-card-singleton-container.mobile-container {
  min-width: 250px;
}

.contact-card-singleton-container.high-contrast {
  border: 1px solid #fff !important;
}
</style>
